// extracted by mini-css-extract-plugin
module.exports = {"MeasurementInfo":"MeasurementInfo_MeasurementInfo__ViLpV","LocationLabel":"MeasurementInfo_LocationLabel__1-JH5"};